import { render } from "./ConfigureWorkflow.vue?vue&type=template&id=20f8b5e7"
import script from "./ConfigureWorkflow.vue?vue&type=script&lang=js"
export * from "./ConfigureWorkflow.vue?vue&type=script&lang=js"

import "./ConfigureWorkflow.vue?vue&type=style&index=0&id=20f8b5e7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__